export default __webpack_public_path__ + "static/media/sideImage1.fc323d3d.png";